var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldShowWebPhone
    ? _c(
        "div",
        {
          staticClass: "webphone-container",
          class: {
            "webphone-minimized": _vm.isMinimized,
            "webphone-maximized": !_vm.isMinimized,
            "webphone-dragging": _vm.isDragging,
            shouldShowContactOverlay:
              _vm.shouldShowContactOverlay &&
              !_vm.isContactOverlayCollapsed &&
              !_vm.isMinimized &&
              _vm.foundContacts.length > 0,
          },
          style: _vm.minimizedStyle,
        },
        [
          _vm.isMinimized
            ? _c(
                "div",
                {
                  staticClass: "webphone-minimized-button",
                  class: {
                    "status-connected": _vm.sipStatus.isRegistered,
                    "status-calling": _vm.callState.status === "calling",
                    "status-ringing": _vm.callState.status === "ringing",
                    "incoming-call": _vm.callState.status === "incoming",
                  },
                  on: { mousedown: _vm.startDrag },
                },
                [
                  _c("div", { staticClass: "status-indicator" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.getMinimizedIcon()) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.callState.status === "incoming"
                    ? _c("div", { staticClass: "incoming-call-info" }, [
                        _c("div", { staticClass: "caller-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.callState.callerName ||
                                _vm.callState.callerNumber
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "webphone-maximized-wrapper",
                  style: _vm.maximizedWrapperStyle,
                },
                [
                  _c("div", { staticClass: "webphone-maximized-content" }, [
                    _c(
                      "div",
                      {
                        staticClass: "webphone-header",
                        on: { mousedown: _vm.startDragMaximized },
                      },
                      [
                        _c("div", { staticClass: "header-left" }, [
                          _c(
                            "div",
                            {
                              staticClass: "sip-status",
                              class: { connected: _vm.sipStatus.isRegistered },
                            },
                            [
                              _c("div", { staticClass: "status-dot" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.sipStatus.isRegistered
                                      ? "Bağlı"
                                      : "Bağlantı Kesildi"
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "header-center" }, [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.$_.get(
                                  _vm.telnyxChannel,
                                  "name",
                                  "Telnyx Phone"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.$_.get(
                            _vm.telnyxChannel,
                            "payload.callerPhoneNumber",
                            null
                          )
                            ? _c("div", { staticClass: "phone-number" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.telnyxChannel.payload
                                        .callerPhoneNumber
                                    ) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "header-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "minimize-btn",
                              on: { click: _vm.toggleMode },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("remove"),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "webphone-tabs" }, [
                      _c(
                        "button",
                        {
                          staticClass: "tab-btn",
                          class: { active: _vm.activeTab === "dialer" },
                          on: {
                            click: function ($event) {
                              _vm.activeTab = "dialer"
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("dialpad"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Tuş Takımı")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "tab-btn",
                          class: { active: _vm.activeTab === "history" },
                          on: {
                            click: function ($event) {
                              _vm.activeTab = "history"
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("history"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Geçmiş")]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "webphone-content" },
                      [
                        _vm.activeTab === "dialer"
                          ? _c("WebPhoneDialer", {
                              ref: "dialerComponent",
                              attrs: {
                                "call-state": _vm.callState,
                                "dial-number": _vm.dialNumber,
                                "sip-status": _vm.sipStatus,
                                extensions: _vm.extensions,
                                mapping: {},
                              },
                              on: {
                                dial: _vm.handleDial,
                                call: _vm.handleCall,
                                hangup: _vm.handleHangup,
                                answer: _vm.handleAnswer,
                                reject: _vm.handleReject,
                                mute: _vm.handleMute,
                                hold: _vm.handleHold,
                                transfer: _vm.handleTransfer,
                                dtmf: _vm.handleDTMF,
                                "number-change": function ($event) {
                                  _vm.dialNumber = $event
                                },
                                "play-dtmf-tone": function ($event) {
                                  return _vm.playDTMFTone($event)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.activeTab === "history"
                          ? _c("WebPhoneCallHistory", {
                              attrs: { "call-history": _vm.callHistory },
                              on: {
                                call: _vm.handleCallFromHistory,
                                "clear-history": _vm.clearCallHistory,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
          _vm._v(" "),
          _vm.isMinimized && _vm.callState.status === "incoming"
            ? _c("div", { staticClass: "incoming-call-notification" }, [
                _c("div", { staticClass: "caller-info" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "caller-details" }, [
                    _c("div", { staticClass: "caller-name" }, [
                      _vm._v(_vm._s(_vm.callState.callerName || "Bilinmeyen")),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "caller-number" }, [
                      _vm._v(_vm._s(_vm.callState.callerNumber)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "call-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "answer-btn",
                      on: { click: _vm.handleAnswer },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("call"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "reject-btn",
                      on: { click: _vm.handleReject },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("call_end"),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("audio", {
            ref: "remoteAudio",
            attrs: {
              id:
                "remoteAudio-" +
                _vm.$_.get(_vm.telnyxChannel, "_id", "default"),
              autoplay: "",
              volume: 1.0,
              muted: false,
            },
          }),
          _vm._v(" "),
          _c("audio", { ref: "ringtone", attrs: { loop: "" } }, [
            _c("source", {
              attrs: {
                src: "https://upload.wikimedia.org/wikipedia/commons/transcoded/3/34/Sound_Effect_-_Door_Bell.ogg/Sound_Effect_-_Door_Bell.ogg.mp3",
                type: "audio/mpeg",
              },
            }),
          ]),
          _vm._v(" "),
          _c("audio", { ref: "ringbacktone", attrs: { loop: "" } }, [
            _c("source", {
              attrs: {
                src: "https://bigsoundbank.com/UPLOAD/mp3/1617.mp3",
                type: "audio/mpeg",
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                visible: _vm.showChannelSelectionModal,
                title: "Telefon Seçin",
                footer: null,
                width: "400px",
              },
              on: { cancel: _vm.cancelChannelSelection },
            },
            [
              _c("div", { staticClass: "channel-selection-content" }, [
                _c("p", { staticClass: "selection-message" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.$_.get(
                          _vm.pendingCallPayload,
                          "phoneNumber",
                          "Bilinmeyen"
                        )
                      )
                    ),
                  ]),
                  _vm._v(
                    " numarasını aramak\n                için hangi telefonu kullanmak istiyorsunuz?\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "channel-list" },
                  _vm._l(_vm.userTelnyxChannels, function (channel) {
                    return _c(
                      "div",
                      {
                        key: channel._id,
                        staticClass: "channel-item",
                        on: {
                          click: function ($event) {
                            return _vm.handleChannelSelection(channel)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "channel-icon" }, [
                          _c("img", {
                            attrs: {
                              src: "/static/img/telnyx.png",
                              alt: "Telnyx",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "channel-info" }, [
                          _c("div", { staticClass: "channel-name" }, [
                            _vm._v(_vm._s(channel.name)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "channel-number" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$_.get(
                                  channel,
                                  "payload.callerPhoneNumber",
                                  null
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "channel-arrow" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("chevron_right"),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caller-avatar" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }